/*
 * @Descripttion: $0
 * @version:
 * @Author: linPing
 * @Date: 2020-07-18 15:33:28
 * @LastEditTime: 2020-07-30 15:04:23
 */

/**
 * 全站http配置
 *
 */
import axios from "axios";
import router from "@/router/";
import { Message } from "element-ui";
import website from "@/config/website";
import qs from "qs";
import Crypto from "crypto-js";
import store from "@/store";
import { decryptDataByToken } from '@/utils/auth'
import { KFGX_API_BASE } from '@/config/kfgxSite'


axios.defaults.timeout = 300000;
//返回其他状态吗
axios.defaults.validateStatus = function(status) {
	return status >= 200 && status <= 500; // 默认的
};
//跨域请求，允许保存cookie
axios.defaults.withCredentials = true;

//HTTPrequest拦截
axios.interceptors.request.use(
	(config) => {
		const meta = config.meta || {};
		if (meta.skip) {
			return config;
		}

		var env = process.env //true;	//正式环境要改为true
		if (env.NODE_ENV == "production") {
			let api_url = KFGX_API_BASE;
			let url = config.url
			url = url.replace('/ds_device', '/api/v1/atc/device')
			url = url.replace('/ds_resource', '/api/v1/resource')
			url = url.replace('/ds_login', '/api/v1')
			config.url = api_url + url;
		}

		config.headers["Content-Type"] = "application/x-www-form-urlencoded";
		if (config.params) {
			config.paramsSerializer = (params) => {
				return qs.stringify(params, {
					indices: false
				});
			};
			if (!config.params.condition) {
				config.params.condition = {
					...config.params,
					page_current: undefined,
					page_size: undefined,
				};
			}
		}

		let token = store.getters.getToken
		// console.log('axios - token', token)
		if(token !== undefined && token !== null && token !== '') {
			config.headers['token'] = token;
		}

		// if(false) {
		// 	if(config.method.toUpperCase() == 'PUT') {
		// 		config.method='POST'
		// 		config.headers['X-HTTP-Method-Override']="PUT"
		// 	}
		// 	if(config.method.toUpperCase() == 'DELETE') {
		// 		config.method='POST'
		// 		config.headers['X-HTTP-Method-Override']="DELETE"
		// 	}
		// }

		if (config.method === 'get') {
			config.params = {
				msg: JSON.stringify(config.params)
			};
		} else {
			// config.data = qs.stringify({
			// 	msg: JSON.stringify(config.data)
			// });


			if(config.url.indexOf("admin_login_check")>-1) {
				console.log('admin_login_check - config.data', config.data);
				let key  = Crypto.enc.Utf8.parse("AB238F8D9X9D813I");
				const srcs = window.CryptoJS.enc.Utf8.parse(JSON.stringify(config.data))
				let encrypt = Crypto.AES.encrypt(srcs, key, {mode:Crypto.mode.ECB,padding: Crypto.pad.Pkcs7});
				let encryptedBase64Data = window.CryptoJS.enc.Base64.stringify(encrypt.ciphertext);
				config.data = qs.stringify({
					msg: encryptedBase64Data
				});
				console.log('admin_login_check - config.data', config.data);
			} else {
				config.data = qs.stringify({
					msg: JSON.stringify(config.data)
				});
			}
			
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

//HTTPresponse拦截
axios.interceptors.response.use(
	(res) => {
		if (res.data.datas) {
			const hideMsg = res.config.meta && res.config.meta.hideErrorMessage
			const status = Number(res.data.status) || 200;
			const statusWhiteList = website.statusWhiteList || [];
			const message = res.data.msg || "未知错误";

			//如果在白名单里则自行catch逻辑处理
			if (statusWhiteList.includes(status)) return Promise.reject(res);

			//如果是401则跳转到登录页面
			if (status === 401) {
				router.push({
					path: ""
				});
			}
			
			// 如果请求为非200否者默认统一处理
			if (status !== 200) {
				!hideMsg && Message({
					message: message,
					type: "error",
				});
				return Promise.reject(new Error(message));
			}

			// 判断是否加密
			if(res.data.enc === 1) {
				res.data.datas = decryptDataByToken(res.data.datas)
			}

			// return res
			return isJSON_test(res.data.datas) ?
				JSON.parse(res.data.datas) :
				res.data.datas;
		} else {
			return res.data;
		}
	},
	(error) => {
		return Promise.reject(new Error(error));
	}
);

function isJSON_test(str) {
	if (typeof str == "string") {
		try {
			JSON.parse(str);
			//console.log('转换成功：'+obj);
			return true;
		} catch (e) {
			// console.log('error：'+str+'!!!'+e);
			return false;
		}
	}
	console.log("It is not a string!");
	return false;
}

export default axios;
